import { siteConfig } from '@/constants/site'

const currencyFormatter = new Intl.NumberFormat(siteConfig.locale, {
    style: 'currency',
    currency: siteConfig.currency
})

export const formatPrice = (amount: number): string => currencyFormatter.format(amount)

export const toCents = (amount: number): number => Math.round(amount * 100)

export const fromCents = (cents: number): number => cents / 100
